import { ChangeDetectionStrategy, Component, Input} from '@angular/core';

@Component({
  selector: 'rl-warn-dialog-window',
  templateUrl: './warn-dialog-window.component.html',
  styleUrls: ['./warn-dialog-window.component.scss', './warn-dialog-window.component-rtl.css'],
  changeDetection : ChangeDetectionStrategy.OnPush
})
export class WarnDialogWindowComponent {

  @Input() message : string;
  @Input() warnTitle? : string;

  constructor() {}
  
  close = () : void => {};

}
